module.exports = __webpack_public_path__ + "img/0.7.bcf4b2ce.png";